import Plan from "../../models/plan.model";
import { ReducerBuilder } from "../../utils/redux/reducer-builder";
import { Invoice } from './../../models/invoice.model';
import { GlobalTypes } from './../global-types';
import { CompanyActionTypes, CompanyState, INITIAL_STATE } from './company-types';

const reduxBuilder = new ReducerBuilder<CompanyState>(INITIAL_STATE);

reduxBuilder.addReducer(GlobalTypes.CLEAR, () => {
    return INITIAL_STATE;
});

reduxBuilder.addMutableReducer(CompanyActionTypes.FETCH_LAST_INVOICE, (state) => {
    state.lastInvoiceData.loading = true;
    state.lastInvoiceData.error = null;
});

reduxBuilder.addMutableReducer<Invoice>(CompanyActionTypes.FETCH_LAST_INVOICE_SUCCESS, (state, payload) => {
    state.lastInvoiceData.loading = false;
    state.lastInvoiceData.data = payload;
});

reduxBuilder.addMutableReducer<any>(CompanyActionTypes.FETCH_LAST_INVOICE_ERROR, (state, error) => {
    state.lastInvoiceData.loading = false;
    state.lastInvoiceData.error = error;
});

reduxBuilder.addMutableReducer(CompanyActionTypes.FETCH_COMPANY_PLAN, (state) => {
    state.planData.loading = true;
    state.planData.error = null;
});

reduxBuilder.addMutableReducer<Plan>(CompanyActionTypes.FETCH_COMPANY_PLAN_SUCCESS, (state, payload) => {
    state.planData.loading = false;
    state.planData.data = payload;
});

reduxBuilder.addMutableReducer<any>(CompanyActionTypes.FETCH_COMPANY_PLAN_ERROR, (state, error) => {
    state.planData.loading = false;
    state.planData.error = error;
});

reduxBuilder.addMutableReducer<any>(CompanyActionTypes.FETCH_PROCESS_STEPS_SUCCESS,(state, payload) => {
      if (state.processStepsFromCompany) {
        state.processStepsFromCompany.data = payload;
      }
    }
  );

reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.CREATE_CANDIDATE_PROCESS_STEP,
    (state) => {
        state.candidateProcessStep = INITIAL_STATE.candidateProcessStep;
        state.candidateProcessStepState = { "error": false, "loading": true };
    }
);

reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.CREATE_CANDIDATE_PROCESS_STEP_SUCCESS,
    (state, payload) => {
        state.candidateProcessStep = payload;
        state.candidateProcessStepState = { "error": false, "loading": false };
    }
);

reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.CREATE_CANDIDATE_PROCESS_STEP_ERROR,
    (state) => {
        state.candidateProcessStepState = { "error": true, "loading": false };
    }
);

reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.FETCH_CANDIDATE_PROCESS_STEP,
    (state) => {
        state.candidateProcessStep = INITIAL_STATE.candidateProcessStep;
        state.candidateProcessStepState = { "error": false, "loading": true };
    }
);

reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.FETCH_CANDIDATE_PROCESS_STEP_SUCCESS,
    (state, payload) => {
        state.candidateProcessStep = payload;
        state.candidateProcessStepState = { "error": false, "loading": false };
    }
);

reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.FETCH_CANDIDATE_PROCESS_STEP_ERROR,
    (state) => {
        state.candidateProcessStepState = { "error": true, "loading": false };
    }
);


reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.UPDATE_CANDIDATE_PROCESS_STEP,
    (state) => {
        state.candidateProcessStepState = { "error": false, "loading": true };
    }
);

reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.UPDATE_CANDIDATE_PROCESS_STEP_SUCCESS,
    (state, payload) => {
        state.candidateProcessStep = payload;
        state.candidateProcessStepState = { "error": false, "loading": false };
    }
);


reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.UPDATE_CANDIDATE_PROCESS_STEP_ERROR,
    (state) => {
        state.candidateProcessStepState = { "error": true, "loading": false };
    }
);


reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.FETCH_SELECTED_CANDIDATES_PROCESS_STEPS,
    (state) => {
        state.selectedCandidatesProcessSteps = INITIAL_STATE.selectedCandidatesProcessSteps;
    }
);

reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.FETCH_SELECTED_CANDIDATES_PROCESS_STEPS_SUCCESS,
    (state, payload) => {
        state.selectedCandidatesProcessSteps = payload;
    }
);

reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.FETCH_SELECTED_CANDIDATES_PROCESS_STEPS_ERROR,
    (state) => {
        state.selectedCandidatesProcessStepsState = { "error": true, "loading": false };
    }
);

reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.FETCH_RECRUITERS, 
    (state) => {
        state.recruiters = INITIAL_STATE.recruiters;
    }
);

reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.FETCH_RECRUITERS_SUCCESS,
    (state, payload) => {
        state.recruiters = payload;
    }
);


reduxBuilder.addMutableReducer<any>(
    CompanyActionTypes.FETCH_RECRUITERS_ERROR,
    (state) => {
        state.recruitersState = { "error": true, "loading": false };
    }
);

        

export default reduxBuilder.build();
